import { Alert, Typography, Card, List } from "antd";

const { Title, Text, Paragraph } = Typography;

const BuildPasswordErrorMessage = (err) => {
  const backendError =
    err?.errors?.[0]?.defaultUserMessage || err?.defaultUserMessage;

  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      {/* General error notice */}
      <Alert
        message="Input Validation Error"
        description={
          <Paragraph style={{ margin: 0, fontSize: 14 }}>
            We couldn't process your request due to some input issues. Please
            review the highlighted fields and ensure they meet the required
            format.
          </Paragraph>
        }
        type="error"
        // showIcon
        style={{ marginBottom: 16 }}
      />

      {/* Password requirements */}
      <Card
        size="small"
        style={{
          background: "#FEF3C7",
          borderLeft: "4px solid #F59E0B",
          borderRadius: 6,
          marginBottom: 16,
        }}
      >
        <Title level={5} style={{ color: "#92400E", marginBottom: 10 }}>
          Password Requirements:
        </Title>
        <List
          size="small"
          dataSource={[
            "Use at least 12 characters, including uppercase, lowercase, special character and a number",
            "Avoid using easily guessable words like 'password'",
            "Avoid using sequential values e.g. '123'",
          ]}
          renderItem={(item) => (
            <List.Item
              style={{ padding: "4px 0", color: "#78350F", fontSize: 13 }}
            >
              {item}
            </List.Item>
          )}
        />
      </Card>

      {/* Backend error if present */}
      {/* {backendError && (
        <Alert
          message="Error Details:"
          description={<Text style={{ fontSize: 13 }}>{backendError}</Text>}
          type="error"
          showIcon
          style={{
            marginTop: 14,
            borderRadius: 6,
            borderLeft: "4px solid #DC2626",
          }}
        />
      )} */}
    </div>
  );
};

export default BuildPasswordErrorMessage;
